import type { HTMLAttributes } from 'react';

import { cn } from '@/shared/lib/cn';

export interface PulseIndicatorProps extends HTMLAttributes<HTMLSpanElement> {
  testID?: string;
}

export function PulseIndicator({ className, testID, ...props }: PulseIndicatorProps) {
  return (
    <span
      role="presentation"
      data-testid={testID}
      className={cn('relative inline-flex h-2.5 w-2.5 items-center justify-center', className)}
      {...props}
    >
      <span
        aria-hidden
        className="absolute inline-flex h-2.5 w-2.5 animate-pulse-ring rounded-pill bg-primary"
      />
      <span aria-hidden className="relative inline-flex h-1 w-1 rounded-pill bg-primary" />
    </span>
  );
}
